import React from "react"
import IntlProps from "../../../state/helpers/IntlProps"
import { ENABLE_MODULE_SECTION_MESSAGES } from "../../../utils/inventory"
import { injectIntl } from "react-intl"
import { useDispatch, useSelector } from "react-redux"
import { InventoryConfigurationSelector } from "../../../state/inventory/configuration/selectors"
import { InventoryConfigurationAction } from "../../../state/inventory/configuration/actions"
import { ToggleWithBackdrop } from "../../../common/toggle"

export const EnableModule = injectIntl((props: IntlProps) => {
    const dispatch = useDispatch()
    const isEnabled = useSelector(InventoryConfigurationSelector.isEnabled)

    const onChange = (isToggled: boolean) => {
        dispatch(InventoryConfigurationAction.update({
            enabled: isToggled
        }))
    }

    return (
        <ToggleWithBackdrop
            onChangeCallback={onChange}
            isEnabled={isEnabled}
            title={props.intl.formatMessage(ENABLE_MODULE_SECTION_MESSAGES["toggleText"])}
            description={props.intl.formatMessage(ENABLE_MODULE_SECTION_MESSAGES["toggleDescription"])}
        />
    )
})




// WEBPACK FOOTER //
// ./src/inventory/sections/settings/EnableModule.tsx